// Canvas media catalog snapshot from ppnew/server/canvas/models.ts.
// Source revision: 5832b8459133c953d4de02e01269dcdb218b49d1
// Membership and labels only; runtime availability remains server-controlled.
export const canvasMediaNames: Record<string, string> = {
  "wan3.0-video": "通义万相 Wan 3.0",
  "ppnew-audio-enhancement-v1": "PPNew 音频增强",
  "ppnew-video-enhancement-v1": "PPNew M4 视频增强",
  "ppnew-image-enhancement-v1": "PPNew M3 图片增强",
  "volc-seedream": "Seedream 5.0",
  "gpt-image-2": "OpenAI GPT Image 2",
  "gpt-image-2.5-flare": "OpenAI GPT Image 2.5 Flare",
  "gemini-3.1-flash-image": "Nano Banana 2",
  "gemini-3-pro-image": "Gemini 3 Pro Image · 高质量",
  "volc-seedance-2.0": "Seedance 2.0",
  "volc-seedance-2.0-fast": "Seedance 2.0 Fast · 4.8 折",
  "volc-seedance-2.0-mini": "Seedance 2.0 Mini · 3.8 折",
  "volc-seedance-2.5": "Seedance 2.5",
  "minimax-image-01": "MiniMax Image-01",
  "minimax-h3": "MiniMax H3",
  "minimax-speech-2.8-hd": "MiniMax Speech 2.8 HD",
  "minimax-speech-2.8-turbo": "MiniMax Speech 2.8 Turbo",
  "volc-jimeng-tts": "Seed TTS 2.0 / Seed ICL 2.0",
  "elevenlabs-sound-effects-v2": "ElevenLabs Sound Effects v2",
  "volc-music-vocal-standard": "豆包音乐 Standard · 免费试用",
  "minimax-music-2.6": "MiniMax Music 2.6",
  "vidu/vidu-image_reference2image": "Vidu Image",
  "vidu/vidu-image-pro_reference2image": "Vidu Image Pro",
  "vidu/vidu-image-lite_reference2image": "Vidu Image Lite",
  "vidu/viduq3-fast_reference2image": "Vidu Q3 Fast",
  "vidu/viduq2-pro_reference2image": "Vidu Q2 Pro",
  "vidu/viduq2-fast_reference2image": "Vidu Q2 Fast"
}
